import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { ExternalComponentDsApiSymbol, name } from '../symbols'
import { ExternalComponentPageConfig, IExternalComponentDsApi, IExternalComponentDsPublicApi } from '../types'

export const ExternalComponentDsApiFactoryFactory = withDependencies(
	[ExternalComponentDsApiSymbol, named(PageFeatureConfigSymbol, name)],
	(
		externalComponentDsApi: IExternalComponentDsApi,
		pageConfig: ExternalComponentPageConfig
	): IExternalComponentDsPublicApi => {
		const cacheKillerCounters: Record<string, number> = {}

		const getNextCacheKillerCounter = (fileUrl: string): number => {
			cacheKillerCounters[fileUrl] = cacheKillerCounters[fileUrl] || 0

			cacheKillerCounters[fileUrl]++
			return cacheKillerCounters[fileUrl]
		}

		const reloadComponentsLinkedToFile: IExternalComponentDsPublicApi['reloadComponentsLinkedToFile'] = async (
			fileUrl
		) => {
			const nextCacheKiller = getNextCacheKillerCounter(fileUrl)
			const componentsIds = pageConfig.moduleUrlToComponentsIds[fileUrl]
			if (componentsIds) {
				componentsIds.forEach((compId) => {
					const compData = pageConfig.externalComponents[compId]

					return externalComponentDsApi.reloadExternalComponent({
						compId,
						data: compData,
						cacheKillerCounter: nextCacheKiller,
					})
				})
			}
		}

		return {
			reloadAllComponents: async () => {
				Object.keys(pageConfig.moduleUrlToComponentsIds).forEach((url) => {
					reloadComponentsLinkedToFile(url)
				})
			},
			reloadComponentsLinkedToFile,
		}
	}
)
